
import store from '../../store'

export default (to: any, from: any, next: any) => {
  const redirectSuite = () => store.dispatch('session/getSuiteHost')
    .then((res) => {
      if (res && res.clientUrl) {
        let urlSuite = res.clientUrl
        if (res.clientPort && (res.clientPort !== 80 || res.clientPort !== 443)) {
          urlSuite = `${urlSuite}:${res.clientPort}`
        }
        location.replace(`${urlSuite}/auth/sso?product=liderazgo`)
      } else {
        next('/404')
      }
    })

  if (!store.state.session.token) {
    redirectSuite()
    return
  }

  store.dispatch('session/isValid')
    .then((res) => {
      if (res) {
        if (store.state.session.user.role === 'customer' && store.state.session.user.customer && store.state.session.user.customer.type === 'commercial' &&
          !store.state.session.user.enterprise) {
          next('/invalid-enterprise')
          return
        }
        next()
      } else {
        store.dispatch('session/signOut')
          .then(() => {
            redirectSuite()
          })
      }
    })
}
